<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_tab_item') }}</v-tab>
      <v-tab href="#tab-2"> {{ $t('quotation_item_tab_month_item') }}</v-tab>
      <v-tab href="#tab-3"> {{ $t('quotation_item_tab_pay_item') }}</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="tryInstallDataTableHeaders"
              :items="tryItemList"
              :search="searchEditedTryInstall"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Index"
              :expanded.sync="expanded"
              :single-expand="singleExpand"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="{ item, expand, isExpanded, index }">
                <tr>
                  <td class="text-start" v-if="item.Number">
                    {{ item.TempStockQuantity }}
                  </td>
                  <td class="text-start" v-else></td>
                  <td class="text-start">
                    {{ item.Number }}
                  </td>
                  <td class="text-start">
                    {{ item.Describe }}
                  </td>
                  <td class="text-start">
                    {{ item.Name }}
                  </td>
                  <td class="text-end">
                    {{ item.Quantity }}
                  </td>
                  <td class="text-end">
                    {{ item.TryQuantity }}
                  </td>
                  <td class="text-start">
                    {{ item.Unit }}
                  </td>
                  <td class="text-end">
                    {{ item.TotalQuantity }}
                  </td>
                  <td class="text-start">
                    {{ turnData(item.InstallPositions) }}
                  </td>
                  <td class="text-center">
                    <v-icon v-if="item.IsCustomerDevice">
                      mdi-check
                    </v-icon>
                    <v-icon v-else>
                      mdi-window-close
                    </v-icon>
                  </td>
                  <td class="text-end" v-if="item.Number && item.Number !== ''">
                    {{ item.RepairPrice }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-end" v-if="item.Number && item.Number !== ''">
                    {{ item.RepairWarrantyPeriod }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-start">
                    {{ item.Remark }}
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      class="mr-2"
                      @click="isShowEditTryInstallDialogBtn(item, index, -1)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="isShowDeleteTryInstallDialogBtn(item, index, -1)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td>
                    <v-icon
                      @click="upTryInstallItem(item)"
                      v-if="index !== 0"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-arrow-up-drop-circle-outline
                    </v-icon>
                    <v-icon
                      @click="downTryInstallItem(item)"
                      v-if="index !== tryItemList.length - 1"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-arrow-down-drop-circle-outline
                    </v-icon>
                  </td>
                  <td v-if="item.Number"></td>
                  <td v-if="!item.Number" class="text-start">
                    <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                      mdi-chevron-up
                    </v-icon>
                    <v-icon @click="expand(!isExpanded)" v-else>
                      mdi-chevron-down
                    </v-icon>
                  </td>
                </tr>
              </template>

              <template v-slot:expanded-item="{ item, index }">
                <tr v-for="(field, idx) in item.BomItems" :key="field.Number">
                  <td class="text-start">
                    {{ field.TempStockQuantity }}
                  </td>
                  <td class="text-start">
                    {{ field.Number }}
                  </td>
                  <td class="text-start">
                    {{ field.Describe }}
                  </td>
                  <td class="text-start">
                    {{ field.Name }}
                  </td>
                  <td class="text-end">
                    {{ field.Quantity }}
                  </td>
                  <td class="text-end">
                    {{ field.TryQuantity }}
                  </td>
                  <td class="text-start">
                    {{ field.Unit }}
                  </td>
                  <td class="text-end">
                    {{ field.TotalQuantity }}
                  </td>
                  <td class="text-start">
                    {{ turnData(field.InstallPositions) }}
                  </td>
                  <td class="text-center">
                    <v-icon v-if="field.IsCustomerDevice">
                      mdi-check
                    </v-icon>
                    <v-icon v-else>
                      mdi-window-close
                    </v-icon>
                  </td>

                  <td class="text-end">
                    {{ field.RepairPrice }}
                  </td>
                  <td class="text-end">
                    {{ field.RepairWarrantyPeriod }}
                  </td>
                  <td class="text-start">
                    {{ field.Remark }}
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      class="mr-2"
                      @click="isShowEditTryInstallDialogBtn(field, index, idx)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="isShowDeleteTryInstallDialogBtn(field, index, idx)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </template>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>試裝</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchEditedTryInstall"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="isShowEditTryInstallDialog = true"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditTryInstallDialog"
                    v-if="isShowEditTryInstallDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ newInstallDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedTryInstall.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedTryInstall.CustomerDeviceType"
                                  :items="computedItemCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedTryInstall.IsCustomerDevice"
                                  ref="customerDeviceTypeAutocomplete"
                                  @keyup.enter="setCustomerDevice"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-item-for-repair-price-autocomplete
                                  :fatherEditedItem="editedTryInstall"
                                  :editedItemIndex="editedTryInstallIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedTryInstall.CustomerDeviceType"
                                  @setEditedItem="setEditedItem"
                                  v-if="editedTryInstallIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="quotationItemAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.Name"
                                    :label="$t('quotation_item_name')"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedTryInstall.TempStockQuantity"
                                  disabled
                                  label="庫存數量"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.Quantity"
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                    @change="changeTotalQuantity"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="試裝車數"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.TryQuantity"
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                    @change="changeTotalQuantity"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      試裝車數
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalQuantity"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedTryInstall.InstallPositions"
                                  :items="allInstallPositionsType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  small-chips
                                  multiple
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  :loading="isLoading"
                                  @keydown.enter="setKeyDownAutocomplete"
                                  @keyup.enter="setKeyUpAutocomplete"
                                  ref="installPositionAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.RepairPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.RepairWarrantyPeriod"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedTryInstall.IsOptionalItem"
                                  label="選配"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedTryInstall.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedTryInstall">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedTryInstallBom">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteTryInstallDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeleteTryInstall"
                    @confirmDelete="confirmDeleteTryInstall"
                  />
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="isShowEditTryInstallBomDialog = true"
                  >
                    {{ $t('quotation_item_new_install_new_bom_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditTryInstallBomDialog"
                    v-if="isShowEditTryInstallBomDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ newInstallDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogBom">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedTryInstall.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedTryInstall.CustomerDeviceType"
                                  :items="computedBomCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedTryInstall.IsCustomerDevice"
                                  ref="bomCustomerDeviceTypeAutocomplete"
                                  @keyup.Enter="SetBomCustomerDeviceType"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-bom-for-repair-price-autocomplete
                                  :fatherEditedItem="editedTryInstall"
                                  :editedItemIndex="editedTryInstallIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedTryInstall.CustomerDeviceType"
                                  @setBomItem="setBomItem"
                                  v-if="editedTryInstallIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.Name"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedTryInstall.Describe"
                                  disabled
                                  label="描述"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.Quantity"
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                    @change="changeTotalQuantity"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="試裝車數"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedTryInstall.TryQuantity"
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                    @change="changeTotalQuantity"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      試裝車數
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalQuantity"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedTryInstall.InstallPositions"
                                  :items="allInstallPositionsType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  @change="setTryInstallPositionQuantity"
                                  @keydown.enter="setKeyDownAutocomplete"
                                  @keyup.enter="setKeyUpAutocomplete"
                                  ref="installPositionAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedTryInstall.IsOptionalItem"
                                  label="選配"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedTryInstall.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedTryInstallBom">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedTryInstallBomBom">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteTryInstallBomDialog"
                    :deleteMessage="'quotation_item_delete_bom_dialog_title'"
                    @closeDelete="closeDeleteTryInstallBom"
                    @confirmDelete="confirmDeleteTryInstallBom"
                  />
                </v-toolbar>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <new-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          @setAllMonth="setAllMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMonthItem="setMonthItem"
          @deleteMonthItem="deleteMonthItem"
          @setMonthBomItemIndex="setMonthBomItemIndex"
          @setBomMonth="setBomMonth"
        />
      </v-tab-item>
      <v-tab-item value="tab-3">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="payItemDataTableHeaders"
              :items="payItemList"
              :search="searchPayItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Name"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t('quotation_item_new_tool_bar_title') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchPayItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="openPayItem"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditPayItemDialog"
                    v-if="isShowEditPayItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_new_pay') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogPayItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <pay-item-autocomplete
                                  :fatherEditedItem="editedPayItem"
                                  :editedItemIndex="editedPayItemIndex"
                                  :itemName="'quotation_item_number'"
                                  @setEditedPayItem="setEditedPayItem"
                                  v-if="editedPayItemIndex === -1"
                                  refName="itemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_car_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_car_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.TotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedPayItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedPayItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedPayItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeletePayItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeletePayItem"
                    @confirmDelete="confirmDeletePayItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditPayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeletePayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-btn
                  icon
                  @click="upPayItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-up-drop-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="downPayItem(item)"
                  v-if="index !== payItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-down-drop-circle-outline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { HttpQuotation, HttpBom, HttpInstallPosition, HttpTempStock } from '@/js/http-Manager'
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import QuotationItemForRepairPriceAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemForRepairPriceAutocomplete.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import PayItemAutocomplete from '@/components/PayItemAutocomplete.vue'
import { PayType } from '@/js/PayType'
import QuotationBomForRepairPriceAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomForRepairPriceAutocomplete.vue'
import NewMonthSetting from '@/components/Quotation/MonthItem/NewMonthSetting.vue'

extend('regex', regex)

export default {
  components: {
    QuotationItemForRepairPriceAutocomplete,
    DeleteDialog,
    PayItemAutocomplete,
    QuotationBomForRepairPriceAutocomplete,
    NewMonthSetting
  },
  name: 'TryInstall',
  data: () => ({
    tempStock: {},
    getIntersectingObj: null,
    isShowEditTryInstallDialog: false,
    isShowDeleteTryInstallDialog: false,
    editedTryInstallIndex: -1,
    searchEditedTryInstall: '',
    editedTryInstall: {
      Id: '',
      Number: '',
      Name: '',
      Quantity: 0,
      TryQuantity: 0,
      Unit: '',
      TotalQuantity: 0,
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      InstallPositions: [],
      CustomerDeviceType: 0,
      IsCustomerDevice: false,
      Remark: '',
      Describe: '',
      IsOptionalItem: false,
      TempStockQuantity: 0,
      BomItems: []
    },
    defaultTryInstall: {
      Id: '',
      Number: '',
      Name: '',
      Quantity: 0,
      TryQuantity: 0,
      Unit: '',
      TotalQuantity: 0,
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      InstallPositions: [],
      CustomerDeviceType: 0,
      IsCustomerDevice: false,
      Remark: '',
      Describe: '',
      IsOptionalItem: false,
      TempStockQuantity: 0,
      BomItems: []
    },

    isShowEditTryInstallBomDialog: false,
    isShowDeleteTryInstallBomDialog: false,
    editedTryInstallBomItemIndex: -1,
    expanded: [],
    singleExpand: true,
    allInstallPositionsType: [],
    isLoading: false,
    bomSource: null,
    computedTotalQuantity: 0,
    computedTotalPrice: 0,

    editedMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 0,
      Quantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      PayType: 1,
      TotalPrice: 0
    },
    defaultMonthItem: {
      Number: '',
      Name: '',
      RentQuantity: 0,
      Quantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      PayType: 1,
      TotalPrice: 0
    },
    editedMonthItemIndex: -1,
    editedMonthBomItemIndex: -1,
    isShowEditMonthItemDialog: false,
    searchMonthItem: '',
    isShowDeleteMonthItemDialog: false,
    searchPayItem: '',
    isShowEditPayItemDialog: false,
    editedPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    defaultPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    editedPayItemIndex: -1,
    isShowDeletePayItemDialog: false,
    customerDeviceTypeList: [],
    tempInstallPositions: [],

    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/
  }),
  async mounted () {
    await this.getAllInstallPositionsType()
    await this.getCustomerDeviceType()
  },
  computed: {
    tryInstallDataTableHeaders () {
      return [
        { text: '實際庫存', align: 'start', value: 'TempStockQuantity' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: '描述', align: 'start', value: 'Describe' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        { text: '試裝車數', align: 'end', value: 'TryQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_total_quantity'), align: 'end', value: 'TotalQuantity' },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPositions'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          justify: 'center',
          value: 'IsCustomerDevice',
          sortable: false
        },
        { text: this.$t('quotation_item_repair_price'), align: 'end', value: 'RepairPrice' },
        {
          text: this.$t('quotation_item_repair_warranty_period'),
          align: 'end',
          value: 'RepairWarrantyPeriod'
        },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    newInstallDialogTitle () {
      return this.editedTryInstallIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    tryItemList () {
      let array = []
      this.tryInstallItemList.forEach((element, index) => {
        element.Index = index
        if (element.Number) {
          element.TempStockQuantity =
            this.fatherTempStockList.find((tempStock) => tempStock.ItemNumber === element.Number)
              ?.CurrentQuantity || 0
        } else {
          element.BomItems.forEach((bomItem) => {
            bomItem.TempStockQuantity =
              this.fatherTempStockList.find((tempStock) => tempStock.ItemNumber === bomItem.Number)
                ?.CurrentQuantity || 0
          })
        }
        array.push(element)
      })
      return array
    },
    monthItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('month_quantity'), align: 'end', value: 'Quantity' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        { text: '收費方式', align: 'start', value: 'PayType' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    payItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },

    computedItemCustomerDeviceTypeList () {
      let array = []
      if (this.editedTryInstall.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedTryInstall.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    },
    computedBomCustomerDeviceTypeList () {
      let array = []
      let isRA400 =
        this.editedTryInstall.BomItems.findIndex((x) => x.Number.includes('RA400')) !== -1
      let hasSerialNumber =
        this.editedTryInstall.BomItems.findIndex((x) => x.HasSerialNumber) !== -1
      if (isRA400) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (hasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }
      return array
    }
  },
  watch: {
    carQuantity (val) {
      if (this.tryInstallItemList.length > 0) {
        this.tryInstallItemList.forEach((element) => {
          if (element.BomItems && element.BomItems.length > 0) {
            element.BomItems.forEach((bomItem) => {
              bomItem.TryQuantity = val
              bomItem.TotalQuantity = val * bomItem.Quantity
            })
          }
          element.TryQuantity = val
          element.TotalQuantity = val * element.Quantity
        })
      }
      if (this.monthItemList.length > 0) {
        this.monthItemList.forEach((element) => {
          element.RentQuantity = val
          element.TotalPrice = val * element.DiscountPrice * element.Quantity
        })
      }
      if (this.payItemList.length > 0) {
        this.payItemList.forEach((element) => {
          element.BuyQuantity = val
          element.TotalPrice = val * element.DiscountPrice
        })
      }
      this.$emit('computedAmt')
    }
  },
  methods: {
    changeTotalQuantity () {
      if (
        this.regexQuantity.test(this.editedTryInstall.TryQuantity) &&
        this.regexQuantity.test(this.editedTryInstall.Quantity)
      ) {
        this.computedTotalQuantity =
          this.editedTryInstall.TryQuantity * this.editedTryInstall.Quantity
        this.editedTryInstall.TotalQuantity = this.computedTotalQuantity
      }
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    setPayTypeAutocomplete (event) {
      this.$refs.payTypeAutocomplete.isMenuActive = false
      this.$refs.payTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setTryInstallPositionQuantity () {
      this.editedTryInstall.Quantity = this.editedTryInstall.InstallPositions.length
      this.editedTryInstall = JSON.parse(JSON.stringify(this.editedTryInstall))
    },

    SetBomCustomerDeviceType (event) {
      this.$refs.bomCustomerDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.bomCustomerDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBomName (event) {
      this.$refs.bomNameAutocomplete.isMenuActive = false
      this.$refs.bomNameAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setCustomerDevice (event) {
      this.$refs.customerDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.customerDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.tempInstallPositions = this.editedTryInstall.InstallPositions
    },
    setKeyUpAutocomplete (event) {
      this.$refs.installPositionAutocomplete.isMenuActive = false
      this.$refs.installPositionAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedTryInstall.InstallPositions = this.tempInstallPositions
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    downPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllPay', temp)
    },
    upPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllPay', temp)
    },
    downMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllMonth', temp)
    },
    upMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllMonth', temp)
    },
    downTryInstallItem (item) {
      let temp = JSON.parse(JSON.stringify(this.tryItemList))
      let currentIndex = temp.findIndex((x) => x.Index === item.Index)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setTryInstall', temp)
    },
    upTryInstallItem (item) {
      let temp = JSON.parse(JSON.stringify(this.tryItemList))
      let currentIndex = temp.findIndex((x) => x.Index === item.Index)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setTryInstall', temp)
    },
    changeIsCustomerDevice () {
      if (this.editedTryInstall.IsCustomerDevice) {
        this.editedTryInstall.CustomerDeviceType = 3
      } else {
        this.editedTryInstall.CustomerDeviceType = 0
      }
      this.editedTryInstall = JSON.parse(JSON.stringify(this.editedTryInstall))
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    changeMonthTotal () {
      if (
        this.regexQuantity.test(this.editedMonthItem.RentQuantity) &&
        this.regexQuantity.test(this.editedMonthItem.Price) &&
        this.regexQuantity.test(this.editedMonthItem.Quantity) &&
        this.regexQuantity.test(this.editedMonthItem.Discount) &&
        this.regexQuantity.test(this.editedMonthItem.DiscountPrice)
      ) {
        this.editedMonthItem.DiscountPrice =
          this.editedMonthItem.Price - this.editedMonthItem.Discount
        this.editedMonthItem.TotalPrice =
          this.editedMonthItem.RentQuantity *
          this.editedMonthItem.DiscountPrice *
          this.editedMonthItem.Quantity *
          1
      }
    },
    changePayTotal () {
      if (
        this.regexPrice.test(this.editedPayItem.Price) &&
        this.regexQuantity.test(this.editedPayItem.BuyQuantity) &&
        this.regexQuantity.test(this.editedPayItem.Discount) &&
        this.regexQuantity.test(this.editedPayItem.DiscountPrice)
      ) {
        this.editedPayItem.DiscountPrice = this.editedPayItem.Price - this.editedPayItem.Discount
        this.editedPayItem.TotalPrice =
          this.editedPayItem.BuyQuantity * this.editedPayItem.DiscountPrice * 1
      }
    },
    async setEditedItem (val) {
      this.editedTryInstall.Id = val.Id
      this.editedTryInstall.Number = val.Number
      this.editedTryInstall.Name = val.Name
      this.editedTryInstall.Unit = val.Unit
      this.editedTryInstall.IsMonthItem = val.IsMonthItem
      this.editedTryInstall.HasSerialNumber = val.HasSerialNumber
      this.editedTryInstall.IsDelete = val.IsDelete
      this.editedTryInstall.StoreNo = val.StoreNo
      this.editedTryInstall.RepairPrice = val.RepairPrice
      this.editedTryInstall.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedTryInstall.Type = val.Type
      await this.getTempStockByItemNumber()
      this.editedTryInstall.TempStockQuantity = this.tempStock.CurrentQuantity
      this.editedTryInstall = JSON.parse(JSON.stringify(this.editedTryInstall))
    },
    setBomItem (val) {
      if (val) {
        this.editedTryInstall.Quantity = 0
        this.editedTryInstall.TryQuantity = 0
        this.editedTryInstall.TotalQuantity = 0
        this.editedTryInstall.Id = val.Id
        this.editedTryInstall.Name = val.Name
        this.editedTryInstall.Number = val.Number
        this.editedTryInstall.Unit = val.Unit
        this.editedTryInstall.Describe = val.Describe
        this.editedTryInstall.Remark = val.Remark
        this.editedTryInstall.BomItems = val.BomItems

        if (this.editedTryInstall.BomItems) {
          this.editedTryInstall.BomItems.forEach((element) => {
            element.IsCustomerDevice = val.IsCustomerDevice
            element.CustomerDeviceType = val.CustomerDeviceType
            element.Quantity = element.Quantity * 1
            element.TryQuantity = element.Quantity * 1
            element.TotalQuantity = element.Quantity * 1
          })
        }
      } else {
        this.editedTryInstall.Quantity = 0
        this.editedTryInstall.TryQuantity = 0
        this.editedTryInstall.TotalQuantity = 0
        this.editedTryInstall.Id = ''
        this.editedTryInstall.Name = ''
        this.editedTryInstall.Number = ''
        this.editedTryInstall.Unit = ''
        this.editedTryInstall.Describe = ''
        this.editedTryInstall.Remark = ''
        this.editedTryInstall.BomItems = []
      }
    },
    turnData (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(
            ItemInstallPositionType.getFormInstallPositionTypeName(
              element,
              this.allInstallPositionsType
            )
          )
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getAllInstallPositionsType () {
      this.isLoading = true
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionsType = response && response.status === 200 ? response.data.Data : []
      this.isLoading = false
    },

    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditTryInstallDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number || item.Number === '') {
        this.editedTryInstallIndex = mainIndex
        this.editedTryInstall = JSON.parse(JSON.stringify(item))
        this.isShowEditTryInstallBomDialog = true
      } else {
        this.editedTryInstallBomItemIndex = subIndex
        this.editedTryInstallIndex = mainIndex
        this.editedTryInstall = JSON.parse(JSON.stringify(item))
        this.isShowEditTryInstallDialog = true
      }
    },
    isShowDeleteTryInstallDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number) {
        this.editedTryInstallIndex = mainIndex
        this.editedTryInstall = JSON.parse(JSON.stringify(item))
        this.isShowDeleteTryInstallBomDialog = true
      } else {
        this.editedTryInstallBomItemIndex = subIndex
        this.editedTryInstallIndex = mainIndex
        this.editedTryInstall = JSON.parse(JSON.stringify(item))
        this.isShowDeleteTryInstallDialog = true
      }
    },
    closeEditedTryInstall () {
      this.isShowEditTryInstallDialog = false
      this.$nextTick(() => {
        this.editedTryInstall = JSON.parse(JSON.stringify(this.defaultTryInstall))
        this.editedTryInstallIndex = -1
        this.editedTryInstallBomItemIndex = -1
      })
    },
    confirmDeleteTryInstall () {
      if (this.editedTryInstall.subIndex !== -1) {
        this.$emit('setTryInstallDeleteBomItemIndex', this.editedTryInstallBomItemIndex)
      }
      this.$emit('setTryInstallDeleteIndex', this.editedTryInstallIndex)
      this.$emit('setDeleteTryInstall', this.editedTryInstall)
      this.closeDeleteTryInstall()
    },
    closeDeleteTryInstall () {
      this.isShowDeleteTryInstallDialog = false
      this.$nextTick(() => {
        this.editedTryInstall = JSON.parse(JSON.stringify(this.defaultTryInstall))
        this.editedTryInstallIndex = -1
        this.editedTryInstallBomItemIndex = -1
      })
    },
    async saveEditedTryInstallBom () {
      const isValid = await this.$refs.dialogItem.validate()
      if (isValid) {
        this.$emit('setTryInstallEditBomItemIndex', this.editedTryInstallBomItemIndex)
        this.$emit('setTryInstallIndex', this.editedTryInstallIndex)
        this.$emit('setEditTryInstall', this.editedTryInstall)
        this.closeEditedTryInstall()
      }
    },

    closeEditedTryInstallBom () {
      this.isShowEditTryInstallBomDialog = false
      this.$nextTick(() => {
        this.editedTryInstall = JSON.parse(JSON.stringify(this.defaultTryInstall))
        this.editedTryInstallIndex = -1
        this.editedTryInstallBomItemIndex = -1
      })
    },
    confirmDeleteTryInstallBom () {
      this.$emit('setTryInstallDeleteIndex', this.editedTryInstallIndex)
      this.$emit('setTryInstallDeleteBomItemIndex', this.editedTryInstallBomItemIndex)
      this.$emit('setDeleteTryInstall', this.editedTryInstall)
      this.closeDeleteTryInstallBom()
    },
    closeDeleteTryInstallBom () {
      this.isShowDeleteTryInstallBomDialog = false
      this.$nextTick(() => {
        this.editedTryInstall = JSON.parse(JSON.stringify(this.defaultTryInstall))
        this.editedTryInstallIndex = -1
        this.editedTryInstallBomItemIndex = -1
      })
    },
    async saveEditedTryInstallBomBom () {
      const isValid = await this.$refs.dialogBom.validate()

      if (isValid) {
        this.$emit('setTryInstallIndex', this.editedTryInstallIndex)
        this.$emit('setTryInstallEditBomItemIndex', this.editedTryInstallBomItemIndex)
        let response = await HttpBom.GetBomById({ bomId: this.editedTryInstall.Id })
        let errorMassage = ''
        if (response && response.status === 200) {
          let bom = response.status === 200 ? response.data.Data : {}
          if (bom) {
            this.editedTryInstall.BomItems.forEach((element) => {
              let bomItem = bom.BomItems.find((x) => x.Id === element.Id)
              if (bomItem) {
                element.Quantity = this.editedTryInstall.Quantity * bomItem.Quantity * 1
                element.TryQuantity = this.editedTryInstall.TryQuantity * 1
                element.TotalQuantity = element.Quantity * element.TryQuantity
                element.InstallPositions = this.editedTryInstall.InstallPositions
                element.IsCustomerDevice = this.editedTryInstall.IsCustomerDevice
                element.CustomerDeviceType = this.editedTryInstall.CustomerDeviceType
              } else {
                errorMassage += 'Bom表Item: 【' + element.Id + ' 】無此Item'
              }
            })
            this.$emit('setEditTryInstall', this.editedTryInstall)
            this.closeEditedTryInstallBom()
          } else {
            errorMassage = 'BOMId: 【' + this.editedTryInstall.Id + ' 】無此BOM'
          }
        } else {
          errorMassage = '取得BOM失敗'
        }
        if (errorMassage) {
          alert(errorMassage)
        }
      }
    },

    setEditedPayItem (val) {
      this.editedPayItem.Id = val.Id
      this.editedPayItem.Number = val.Number
      this.editedPayItem.Name = val.Name
      this.editedPayItem.Unit = val.Unit
      this.editedPayItem.Price = val.Price
      this.editedPayItem.IsDelete = val.IsDelete
      this.editedPayItem.StoreNo = val.StoreNo
      this.changePayTotal()
      this.editedPayItem = JSON.parse(JSON.stringify(this.editedPayItem))
    },
    closeEditedPayItem () {
      this.isShowEditPayItemDialog = false
      this.editedPayItem = JSON.parse(JSON.stringify(this.defaultPayItem))
      this.editedPayItemIndex = -1
    },
    openPayItem () {
      this.editedPayItem.BuyQuantity = this.carQuantity
      this.isShowEditPayItemDialog = true
    },
    isShowEditPayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.editedPayItem = JSON.parse(JSON.stringify(item))
      this.isShowEditPayItemDialog = true
    },
    async saveEditedPayItem () {
      const isValid = await this.$refs.dialogPayItem.validate()
      if (isValid) {
        this.$emit('setPayItemIndex', this.editedPayItemIndex)
        this.$emit('setPayItem', this.editedPayItem)
        this.closeEditedPayItem()
      }
    },
    isShowDeletePayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.isShowDeletePayItemDialog = true
    },
    closeDeletePayItem () {
      this.editedPayItemIndex = -1
      this.isShowDeletePayItemDialog = false
    },
    confirmDeletePayItem () {
      this.$emit('deletePayItem', this.editedPayItemIndex)
      this.closeDeletePayItem()
    },

    setDiscountItemIndex (index) {
      this.$emit('setDiscountItemIndex', index)
    },
    setDiscountItem (val) {
      this.$emit('setDiscountItem', val)
    },
    deleteDiscountItem (index) {
      this.$emit('deleteDiscountItem', index)
    },
    setAllDiscount (temp) {
      this.$emit('setAllDiscount', temp)
    },

    setAllMonth (temp) {
      this.$emit('setAllMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMonthItem (val) {
      this.$emit('setMonthItem', val)
    },
    deleteMonthItem () {
      this.$emit('deleteMonthItem')
    },
    setMonthBomItemIndex (bomIndex) {
      this.$emit('setMonthBomItemIndex', bomIndex)
    },
    setBomMonth () {
      this.$emit('setBomMonth')
    },
    async getTempStockByItemNumber () {
      let response = await HttpTempStock.GetTempStockByItemNumber({
        itemNumber: this.editedTryInstall.Number
      })
      this.tempStock =
        response && response.status === 200 && response.data.Data
          ? JSON.parse(JSON.stringify(response.data.Data))
          : {}
    }
  },
  props: [
    'tryInstallItemList',
    'isAllTextFieldDisabled',
    'repairCustomerId',
    'monthItemList',
    'payItemList',
    'carQuantity',
    'discountItemList',
    'allPayType',
    'allPayQuantityType',
    'fatherTempStockList'
  ]
}
</script>
